import {observer} from 'mobx-react';
import React, {useCallback, useMemo} from 'react';
import {Table, useWindowSize} from '@vidazoo/ui-kit';
import theme from './theme.module.scss';
import useChangeLogsModel from '../../common/hooks/useChangeLogsModel';
import ChangeLogsRow from '../changeLogRow/ChangeLogsRow';
import ChangeLogsTableHeader from '../changeLogsTableHeader/ChangeLogsTableHeader';

export default observer(function ChangeLogsList() {
    const model = useChangeLogsModel();
    const {width} = useWindowSize();
    const scrollbarHeight = useMemo(() => {
        const probe = document.createElement('div');
        probe.style.cssText = 'position:absolute;left:-9999px;width:100px;height:100px;overflow:scroll';
        document.body.appendChild(probe);
        const size = probe.offsetHeight - probe.clientHeight;
        probe.remove();
        return size;
    }, []);
    const horizontalScrollbar = model.rowWidth > Math.min(width ?? window.innerWidth, document.documentElement.clientWidth) ? scrollbarHeight : 0;
    const renderRow = useCallback((itemIndex, viewportIndex, style) =>
        <ChangeLogsRow key={model.maskItems[itemIndex]?.id || itemIndex} itemIndex={itemIndex} viewportIndex={viewportIndex} style={style}/>, [model]);
    const renderHeader = useCallback(() => <ChangeLogsTableHeader/>, []);
    if (model.items.isLoading) return <div className={theme.message} role="status">Loading<br/>Please wait...</div>;
    if (model.items.error) return <div className={theme.message} role="alert">Failed to get change logs. <button type="button" onClick={model.getItems}>Retry</button></div>;
    return <div className={theme.list}><Table className={theme.table} itemsCount={model.maskItems.length} rowHeight={60}
        viewportHeight={model.maskItems.length * 60 + 67 + horizontalScrollbar} renderRow={renderRow} renderHeader={renderHeader} columnsManager={model} overscanItems={5} useStickyScrollbar/></div>;
});
